export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-60x60-c649ed35443b09cd50e11fea7ca28049.png";